<script lang="ts">
	import HdSchedule from '#lib/hockeydata/components/HDSchedule.svelte';
	import { findOwnTeamId } from '#lib/hockeydata/hockeydata.js';
	import { getDivisionInfo } from '#lib/hockeydata/hockeydata.remote.js';
	import type { Schedule } from '#lib/schema-extension.js';
	import { asObjectOrUndefined } from '../directus.js';
	import { setAttr } from '@directus/visual-editing';

	let { block }: { block: Schedule } = $props();

	const hdSeason = $derived.by(async () => {
		if (!block.season || typeof block.season === 'number') {
			return;
		}
		return await getDivisionInfo(block.season);
	});

	const ownTeamId = $derived(findOwnTeamId((await hdSeason)?.data.teams ?? []));
</script>

<div
	data-directus={setAttr({
		collection: 'schedule',
		item: block.id!!,
		mode: 'modal'
	})}
>
	<HdSchedule
		title={block.title}
		season={asObjectOrUndefined(block.season)}
		teamId={ownTeamId?.toString()}
	/>
</div>
